import { render, staticRenderFns } from "./ItemFormRow.vue?vue&type=template&id=089a3be0&scoped=true&lang=html"
import script from "./ItemFormRow.vue?vue&type=script&lang=js"
export * from "./ItemFormRow.vue?vue&type=script&lang=js"
import style0 from "./ItemFormRow.vue?vue&type=style&index=0&id=089a3be0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "089a3be0",
  null
  
)

export default component.exports